<!-- Similasyon V1 - FikoDialogCore icinde gosterilir -->
<div style="min-width:360px;color:white;text-shadow: 0 0 10px rgb(0 255 255 / 95%);font-size: 1em;transition:box-shadow 0.15s;overflow:visible;"
    [style.boxShadow]="carpismaFlash > 0 ? '0 0 30px rgba(255,0,0,0.8), inset 0 0 15px rgba(255,0,0,0.3)' : ''">

    <div>
        <div class="ui icon mini buttons" style="width: 100%;">
            <button class="ui button" (click)="poz=pozMin;pozisyonDegisti();">
                <i class="backward icon"></i>
            </button>
            <button class="ui button" (click)="tiklandiGeriOynat()">
                <i class="horizontally flipped play icon"></i>
            </button>
            <button class="ui button" (click)="tiklandiDuraklat()">
                <i class="pause icon"></i>
            </button>
            <button class="ui button" (click)="tiklandiIleriOynat()">
                <i class="play icon"></i>
            </button>
            <button class="ui button" (click)="poz=pozMax;pozisyonDegisti();">
                <i class="forward icon"></i>
            </button>
        </div>

        <input type="range" [min]="pozMin" [max]="pozMax" tabindex="0" [ngModel]="poz" [step]="1"
            (ngModelChange)="poz=$event;CD.detectChanges();pozisyonDegisti();"
            style="width: 100%;margin-top: 0.5rem;pointer-events: all;" />

        <!-- Timeline: hareket turu segmentleri + operasyon sinir cizgileri -->
        <div *ngIf="operasyonIsaretleri?.length" class="timeline-bar">
            <!-- Hareket turu segmentleri -->
            <div *ngFor="let isaret of operasyonIsaretleri"
                class="timeline-segment"
                [style.left.%]="(isaret.baslangic / pozMax) * 100"
                [style.width.%]="((isaret.bitis - isaret.baslangic) / pozMax) * 100"
                [style.background]="isaret.renk"
                [title]="isaret.isim + ' - ' + isaret.hareketTuru + ' (' + isaret.baslangic + '-' + isaret.bitis + ')'"
                (click)="tiklandiOperasyon(isaret)">
                <span class="timeline-label" *ngIf="((isaret.bitis - isaret.baslangic) / pozMax) > 0.06">
                    {{ isaret.hareketTuru }}
                </span>
            </div>
            <!-- Operasyon sinirlari (dikey beyaz cizgiler) -->
            <div *ngFor="let sinir of operasyonSinirlari"
                class="timeline-sinir"
                [style.left.%]="(sinir.pozisyon / pozMax) * 100"
                [title]="sinir.isim">
            </div>
        </div>

        <div class="ui divider" style="margin-top: 0.3rem;margin-bottom:0.3rem;"></div>

        <div style="display: flex;">

            <div style="display: flex;flex-direction: column;max-width: 120px;margin-right: 0.5rem;">
                <span style="flex:0;">
                    Başlangıç :
                    <div style="display: flex;">
                        <button class="ui icon button" title="Sıfırla" style="padding: 0.2rem;">
                            <i class="creative commons zero icon"></i>
                        </button>
                        <input class="fikoinput" type="number" placeholder="Seç" size="1" style="flex:1;" [min]="0"
                            [ngModel]="pozMin"
                            (ngModelChange)="pozMin=$event;CD.detectChanges();pozisyonDegisti();">
                        <button class="ui icon button" title="Pozisyon Seç" style="padding: 0.2rem;">
                            <i class="mouse pointer icon"></i>
                        </button>
                    </div>
                </span>

                <span style="flex:0">
                    Şimdiki :
                    <div style="display: flex;">
                        <button class="ui icon button" title="Sıfırla" style="padding: 0.2rem;">
                            <i class="creative commons zero icon"></i>
                        </button>
                        <input class="fikoinput" type="number" placeholder="Seç" size="1" style="flex:1;"
                            [min]="pozMin" [max]="pozMax" [ngModel]="poz"
                            (ngModelChange)="poz=$event;CD.detectChanges();pozisyonDegisti();">
                        <button class="ui icon button" title="Pozisyon Seç" style="padding: 0.2rem;">
                            <i class="mouse pointer icon"></i>
                        </button>
                    </div>
                </span>
                <span style="flex:0">
                    Bitiş :
                    <div style="display: flex;">
                        <button class="ui icon button" title="Sıfırla" style="padding: 0.2rem;">
                            <i class="creative commons zero icon"></i>
                        </button>
                        <input class="fikoinput" type="number" placeholder="Seç" size="1" style="flex:1;"
                            [ngModel]="pozMax" (ngModelChange)="pozMax=$event;CD.detectChanges();pozisyonDegisti();"
                            [max]="noktalar?.length">
                        <button class="ui icon button" title="Pozisyon Seç" style="padding: 0.2rem;">
                            <i class="mouse pointer icon"></i>
                        </button>
                    </div>
                </span>
            </div>

            <div style="flex: 1;">
                <div style="display:flex;align-items:center;gap:4px;margin-top:0.5rem;">
                    <input type="range" [min]="1" [max]="1000" tabindex="0" [ngModel]="simHizi" [step]="1"
                        (ngModelChange)="simHizi=$event;" style="flex:1;" />
                    <button class="ui icon mini button"
                            style="padding:0.2rem;margin:0;width:24px;height:24px;"
                            [style.background]="cizgiUzerindeIlerle ? '#2185d0' : ''"
                            title="Çizgi Üzerinde İlerleme"
                            (click)="tiklandiCizgiModuToggle();">
                        <i class="road icon" style="margin:0;"></i>
                    </button>
                </div>
                <div>
                    {{ aktifOperasyonIsmi }} | {{ aktifHareketTuru }} | {{ aktifNokta?.takim?.cap }} R{{ aktifNokta?.takim?.radius }}
                </div>
                <div style="text-align: center;">
                    {{ 'Üst Açı='+(gostergeAci?.ustAci | number:'1.3-3')
                    +' Alt Açı='+(gostergeAci?.altAci|number:'1.3-3')}}
                </div>

                <div style="text-align: center;">
                    Kaçma Değerleri
                </div>
                <div style="text-align: center;">
                    X:{{ gostergeKacmaDegerleri?.x?.toFixed(4) }} Y:{{gostergeKacmaDegerleri?.y?.toFixed(4) }} Z:{{
                    gostergeKacmaDegerleri?.z?.toFixed(4) }}</div>
                <div style="text-align: center;display:flex;align-items:center;justify-content:center;gap:4px;flex-wrap:wrap;">
                    <span style="flex:1;min-width:100px;">{{islemeEkseni?.name}}</span>
                    <!-- Kütük Simülasyonu Butonları -->
                    <button class="ui icon mini button"
                            style="padding:0.2rem;margin:0;"
                            [style.background]="kutukSimAktif ? '#21ba45' : kutukMeshSecili ? '#2185d0' : ''"
                            [title]="kutukSimAktif ? 'Kütük Sim. AÇIK - Kapat' : kutukMeshSecili ? 'Kütük Seçili - Başlat' : 'Kütük Simülasyonu (önce seç)'"
                            (click)="tiklandiKutukSimToggle()">
                        <i class="cube icon"></i>
                    </button>
                    <button class="ui icon mini button"
                            style="padding:0.2rem;margin:0;"
                            [style.background]="kutukSecimModu ? '#f2711c' : ''"
                            [style.animation]="kutukSecimModu ? 'pulse 1s infinite' : ''"
                            [title]="kutukSecimModu ? 'SEÇİM MODU - Kütük tıkla!' : 'Kütük Seç (Ürün Ağacı/3D)'"
                            (click)="tiklandiKutukSec()">
                        <i [class]="kutukSecimModu ? 'bullseye icon' : 'crosshairs icon'"></i>
                    </button>
                </div>
                <!-- Kütük Durumu -->
                <div *ngIf="kutukSecimModu || kutukMeshSecili || kutukSimAktif"
                     style="text-align:center;font-size:9px;margin-top:2px;"
                     [style.color]="kutukSecimModu ? '#f2711c' : kutukSimAktif ? '#21ba45' : '#2185d0'">
                    <span *ngIf="kutukSecimModu">⏳ Kütük seçimi bekleniyor...</span>
                    <span *ngIf="!kutukSecimModu && kutukMeshSecili && !kutukSimAktif">✓ Kütük seçildi</span>
                    <span *ngIf="kutukSimAktif">🔧 Sim. aktif | Kaldırılan: {{kutukKaldirilanHacim.toFixed(1)}} cm³</span>
                </div>

                <!-- Simülasyon Motoru Dialog Aç Butonu -->
                <button *ngIf="kutukMeshSecili"
                    class="ui icon button" style="padding: 0.3rem 0.5rem; margin-top:4px;"
                    [style.background]="kutukSimAktif ? '#21ba45' : 'rgba(30,30,50,0.6)'"
                    [style.border]="'1px solid rgba(0,255,255,0.3)'"
                    (click)="simMotorDialogAc()"
                    title="Simülasyon Motoru Ayarları Penceresi">
                    <i class="cogs icon" style="color:#0ff;"></i>
                    <span style="font-size:9px;margin-left:4px;color:#0ff;">Sim. Motoru</span>
                    <span style="font-size:7px;margin-left:4px;color:#888;">{{kutukSimModu}}</span>
                    <i class="external alternate icon" style="font-size:8px;margin-left:4px;color:#0ff;opacity:0.6;"></i>
                </button>
            </div>


        </div>
        <div class="ui divider" style="margin-top: 0.1rem;margin-bottom:0.1rem;"></div>

        <div>
            <span> İlerleme: {{ (aktifNokta?.hiz * (reelIlerleme / 100)).toFixed(0) }}mm_dk |
                <span style="text-shadow:  0px 0px 5px #fff;">
                    {{ aktifNokta?.hareketTuru }}
                </span>
            </span>
            <span style="float: right;">Devir: {{ aktifNokta?.devir }}rpm</span>
        </div>

        <div>{{ 'X='+(gostergeNokta?.x?.toFixed(6)) + ' Y='+(gostergeNokta?.y?.toFixed(6)) + '
            Z='+(gostergeNokta?.z?.toFixed(6)) }}</div>

        <div style="text-align: center;">Geçen : {{ aktifNokta?.guncelSure / (reelIlerleme / 100) |
            insancaSaniye }} Toplam : {{ aktifNokta?.toplamSure / (reelIlerleme / 100) | insancaSaniye }} </div>

        <div>Reel Yüzdelik İlerleme : %{{ reelIlerleme }}</div>
        <input type="range" [min]="1" [max]="200" tabindex="0" [ngModel]="reelIlerleme" [step]="1"
            (ngModelChange)="reelIlerleme=$event;CD.detectChanges();" style="width: 100%;margin-top: 0.5rem;" />
    </div>

    <div class="ui divider" style="margin-top: 0.3rem;margin-bottom:0.3rem;"></div>

    <div style="display:flex;align-items:center;gap:4px;">
        <!-- Araçlar Popup Butonu -->
        <button class="ui icon button"
            title="Araçlar Paneli"
            style="padding: 0.4rem 0.6rem; anchor-name: --araclar-anchor;"
            popovertarget="sim-araclar-popup">
            <i class="th icon" style="width: 16px;"></i>
            <span style="font-size:11px;margin-left:4px;">Araçlar</span>
            <i class="angle down icon" style="width:12px;margin-left:2px;"></i>
        </button>

        <span style="flex:1;"></span>

        <div class="ui animated mini button" tabindex="0" (click)="kapa()">
            <div class="visible content">Kapat</div>
            <div class="hidden content">
                <i class="check icon"></i>
            </div>
        </div>
    </div>

    <!-- Araçlar Popover Panel -->
    <div id="sim-araclar-popup" popover
        style="margin:0; inset:unset;
               position-anchor: --araclar-anchor;
               top: anchor(bottom); left: anchor(left);
               margin-top: 4px;
               background:linear-gradient(135deg, rgba(18,22,30,0.98), rgba(25,30,42,0.98));
               border:1px solid rgba(0,255,255,0.4); border-radius:8px; padding:8px;
               backdrop-filter:blur(12px); color:white;
               box-shadow: 0 4px 20px rgba(0,0,0,0.6), 0 0 20px rgba(0,255,255,0.15);
               min-width:200px; font-size:9px;">

        <!-- GÖRÜNÜM -->
        <div style="color:#0af;margin-bottom:2px;font-weight:600;letter-spacing:0.5px;">GÖRÜNÜM</div>
        <div style="display:flex;flex-wrap:wrap;gap:2px;margin-bottom:6px;">
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Simülasyon Çizgisi Göster/Gizle"
                [style.background]="similasyonCizgisi.visible ? '#2185d0' : '#555'"
                (click)="similasyonCizgisi.visible=!similasyonCizgisi.visible;ciz();CD.detectChanges();">
                <i class="route icon"></i>
            </button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Çizgi Önde/Arkada"
                (click)="simCizgiOnde=!simCizgiOnde;CD.detectChanges();">
                <img src="/simgeler/takimyolu.webp" style="width:12px;height:12px;">
            </button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Renk"
                (click)="tekRenk=!tekRenk;CD.detectChanges();"><i class="color palette icon"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Noktalar"
                (click)="similasyonNoktalar.visible=!similasyonNoktalar.visible;ciz();CD.detectChanges();"><i class="vector square icon"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Düzenle"><i class="edit icon"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Tutucu" (click)="tiklandiTutucuTanimla()"><i class="cube icon"></i></button>
        </div>

        <!-- KAMERA -->
        <div style="color:#0af;margin-bottom:2px;font-weight:600;letter-spacing:0.5px;">KAMERA</div>
        <div style="display:flex;flex-wrap:wrap;gap:2px;margin-bottom:3px;">
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;"
                [style.background]="kameraModu === 1 ? '#2185d0' : kameraModu === 2 ? '#a333c8' : ''"
                [title]="kameraModu === 0 ? 'Kilitle' : kameraModu === 1 ? 'Drone' : 'Serbest'"
                (click)="tiklandiKameraKilitle()">
                <i [class]="kameraModu === 0 ? 'search icon' : kameraModu === 1 ? 'lock icon' : 'video icon'"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Yön Oku"
                [style.background]="yonOkuGorunur ? '#2185d0' : ''"
                (click)="yonOkuGorunur=!yonOkuGorunur;pozisyonDegisti();CD.detectChanges();"><i class="location arrow icon"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="HUD"
                [style.background]="hudAktif ? '#00b5ad' : ''"
                (click)="tiklandiHudToggle()"><i class="crosshairs icon"></i></button>
        </div>
        <!-- Kamera Slider'ları -->
        <div *ngIf="kameraModu === 1" style="display:flex;align-items:center;gap:3px;margin-bottom:3px;">
            <span style="min-width:28px;">Takip</span>
            <input type="range" [min]="0" [max]="100" [ngModel]="kameraYumusaklik" (ngModelChange)="kameraYumusaklik=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
            <span style="min-width:32px;text-align:right;color:#88f;">{{kameraYumusaklik < 30 ? 'Hızlı' : kameraYumusaklik < 70 ? 'Orta' : 'Ağır'}}</span>
        </div>
        <div *ngIf="kameraModu === 2" style="background:rgba(163,51,200,0.15);border-radius:4px;padding:3px;margin-bottom:3px;">
            <div style="display:flex;align-items:center;gap:3px;">
                <span style="min-width:28px;">Hız</span>
                <input type="range" [min]="0" [max]="100" [ngModel]="droneHiz" (ngModelChange)="droneHiz=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#d9a5f0;">%{{droneHiz}}</span>
            </div>
            <div style="display:flex;align-items:center;gap:3px;margin-top:2px;">
                <span style="min-width:28px;">Mesafe</span>
                <input type="range" [min]="0" [max]="100" [ngModel]="droneMesafe" (ngModelChange)="droneMesafe=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#d9a5f0;">%{{droneMesafe}}</span>
            </div>
            <div style="display:flex;align-items:center;gap:3px;margin-top:2px;">
                <span style="min-width:28px;">Açı</span>
                <input type="range" [min]="0" [max]="100" [ngModel]="droneYukseklik" (ngModelChange)="droneYukseklik=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#d9a5f0;">{{droneYukseklik < 50 ? 'Alçak' : 'Yüksek'}}</span>
            </div>
        </div>
        <div *ngIf="hudAktif" style="display:flex;align-items:center;gap:3px;margin-bottom:3px;">
            <span style="min-width:28px;color:#0ff;">HUD</span>
            <input type="range" [min]="0" [max]="100" [ngModel]="hudBoyut" (ngModelChange)="hudBoyut=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
            <span style="min-width:32px;text-align:right;color:#0ff;">{{hudBoyut < 50 ? 'Küçük' : 'Büyük'}}</span>
        </div>

        <!-- DIRECTOR MODE -->
        <div style="color:#f36;margin-bottom:2px;font-weight:600;letter-spacing:0.5px;margin-top:3px;">DIRECTOR</div>
        <div style="display:flex;flex-wrap:wrap;gap:2px;margin-bottom:6px;">
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;"
                (click)="directorModeAc()"
                title="Director Mode Penceresi Aç">
                <i class="film icon"></i>
            </button>
        </div>

        <!-- EFEKTLER -->
        <div style="color:#0af;margin-bottom:2px;font-weight:600;letter-spacing:0.5px;margin-top:3px;">EFEKTLER</div>
        <div style="display:flex;flex-wrap:wrap;gap:2px;margin-bottom:3px;">
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Ses"
                [style.background]="sesAktif ? '#2185d0' : ''" (click)="tiklandiSesToggle()">
                <i [class]="sesAktif ? 'volume up icon' : 'volume off icon'"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Talaş"
                [style.background]="talasAktif ? '#2185d0' : ''" (click)="talasAktif=!talasAktif;CD.detectChanges();"><i class="fire icon"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Titreşim"
                [style.background]="titresimAktif ? '#2185d0' : ''" (click)="titresimAktif=!titresimAktif;CD.detectChanges();"><i class="heartbeat icon"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;"
                [style.background]="efektModu === 1 ? '#00b5ad' : efektModu === 2 ? '#21ba45' : ''"
                [title]="efektModu === 0 ? 'Lazer' : efektModu === 1 ? 'Hayalet' : 'Kapat'" (click)="tiklandiEfektToggle()">
                <i [class]="efektModu < 2 ? 'bolt icon' : 'ghost icon'"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Sonar"
                [style.background]="sonarAktif ? '#6435c9' : ''" (click)="tiklandiSonarToggle()"><i class="wifi icon"></i></button>
        </div>
        <!-- Ses Ayarları -->
        <div *ngIf="sesAktif" style="background:rgba(33,133,208,0.1);border:1px solid rgba(33,133,208,0.25);border-radius:4px;padding:4px;margin-bottom:3px;">
            <div style="display:flex;align-items:center;gap:2px;height:14px;">
                <span style="min-width:32px;color:#4af;">Vol</span>
                <input type="range" [min]="0" [max]="100" [step]="5"
                    [ngModel]="sesMasterVolume" (ngModelChange)="sesMasterVolume=$event;sesAyarlariGuncelle();CD.detectChanges();"
                    style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#4af;font-size:7px;">%{{sesMasterVolume}}</span>
            </div>
            <div style="display:flex;align-items:center;gap:2px;height:14px;">
                <span style="min-width:32px;color:#f90;">Kesim</span>
                <input type="range" [min]="0" [max]="100" [step]="5"
                    [ngModel]="sesKesimMix" (ngModelChange)="sesKesimMix=$event;sesAyarlariGuncelle();CD.detectChanges();"
                    style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#f90;font-size:7px;">%{{sesKesimMix}}</span>
            </div>
            <div style="display:flex;align-items:center;gap:2px;height:14px;">
                <span style="min-width:32px;color:#c6f;">Harm</span>
                <input type="range" [min]="0" [max]="100" [step]="5"
                    [ngModel]="sesHarmonikMix" (ngModelChange)="sesHarmonikMix=$event;sesAyarlariGuncelle();CD.detectChanges();"
                    style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#c6f;font-size:7px;">%{{sesHarmonikMix}}</span>
            </div>
            <div style="display:flex;align-items:center;gap:2px;height:14px;">
                <span style="min-width:32px;color:#8b8;">Grlt</span>
                <input type="range" [min]="0" [max]="100" [step]="5"
                    [ngModel]="sesGurultuMix" (ngModelChange)="sesGurultuMix=$event;sesAyarlariGuncelle();CD.detectChanges();"
                    style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#8b8;font-size:7px;">%{{sesGurultuMix}}</span>
            </div>
            <div style="display:flex;align-items:center;gap:2px;height:14px;">
                <span style="min-width:32px;color:#aaa;">Servo</span>
                <input type="range" [min]="0" [max]="100" [step]="5"
                    [ngModel]="sesServoMix" (ngModelChange)="sesServoMix=$event;sesAyarlariGuncelle();CD.detectChanges();"
                    style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#aaa;font-size:7px;">%{{sesServoMix}}</span>
            </div>
            <div style="display:flex;align-items:center;gap:2px;height:14px;">
                <span style="min-width:32px;color:#ff0;">Pitch</span>
                <input type="range" [min]="0" [max]="100" [step]="5"
                    [ngModel]="sesPitch" (ngModelChange)="sesPitch=$event;sesAyarlariGuncelle();CD.detectChanges();"
                    style="flex:1;height:2px;margin:0;">
                <span style="min-width:24px;text-align:right;color:#ff0;font-size:7px;">{{sesPitch < 40 ? 'Bas' : sesPitch > 60 ? 'Tiz' : 'Ntr'}}</span>
            </div>
        </div>
        <!-- Efekt Slider'ları -->
        <div *ngIf="talasAktif" style="display:flex;align-items:center;gap:3px;margin-bottom:2px;">
            <span style="min-width:28px;color:#f80;">Talaş</span>
            <input type="range" [min]="0" [max]="200" [ngModel]="talasSiddetCarpan" (ngModelChange)="talasSiddetCarpan=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
            <span style="min-width:24px;text-align:right;color:#f80;">%{{talasSiddetCarpan}}</span>
            <label style="display:flex;align-items:center;gap:2px;cursor:pointer;margin-left:4px;" title="Gerçekçi Fizik: Takım yönüne göre talaş fırlatır">
                <input type="checkbox" [(ngModel)]="talasGercekFizik" style="margin:0;cursor:pointer;">
                <span style="font-size:0.75em;color:#fa0;">Fizik</span>
            </label>
        </div>
        <div *ngIf="titresimAktif" style="display:flex;align-items:center;gap:3px;margin-bottom:2px;">
            <span style="min-width:28px;color:#f48;">Titreş</span>
            <input type="range" [min]="0" [max]="200" [ngModel]="titresimSiddetCarpan" (ngModelChange)="titresimSiddetCarpan=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
            <span style="min-width:24px;text-align:right;color:#f48;">%{{titresimSiddetCarpan}}</span>
        </div>
        <div *ngIf="efektModu === 2" style="display:flex;align-items:center;gap:3px;margin-bottom:2px;">
            <span style="min-width:28px;color:#0fa;">Ghost</span>
            <input type="range" [min]="0" [max]="100" [ngModel]="hayaletMesafe" (ngModelChange)="hayaletMesafe=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
            <span style="min-width:24px;text-align:right;color:#0fa;">{{hayaletMesafe < 50 ? 'Yakın' : 'Uzak'}}</span>
        </div>
        <div *ngIf="sonarAktif" style="display:flex;align-items:center;gap:3px;margin-bottom:2px;">
            <span style="min-width:28px;color:#b7f;">Sonar</span>
            <input type="range" [min]="0" [max]="100" [ngModel]="sonarHiz" (ngModelChange)="sonarHiz=$event;CD.detectChanges();" style="flex:1;height:2px;margin:0;">
            <span style="min-width:24px;text-align:right;color:#b7f;">{{sonarHiz < 50 ? 'Yavaş' : 'Hızlı'}}</span>
        </div>

        <!-- ANALİZ -->
        <div style="color:#0af;margin-bottom:2px;font-weight:600;letter-spacing:0.5px;margin-top:3px;">ANALİZ</div>
        <div style="display:flex;align-items:center;gap:4px;flex-wrap:wrap;">
            <button class="ui icon mini button" style="padding:0.2rem;margin:0;" title="Çarpışma (Canlı)"
                [style.background]="carpismaKontrolAktif ? '#db2828' : ''" (click)="tiklandiCarpismaToggle()"><i class="shield alternate icon"></i></button>
            <button class="ui icon mini button" style="padding:0.2rem 0.4rem;margin:0;font-size:9px;"
                [style.background]="carpismaTaramaYapiliyor ? '#f90' : '#06a'"
                [disabled]="carpismaTaramaYapiliyor"
                (click)="tumCarpismalariTara()" title="Tüm simülasyonu tara">
                <i class="search icon" *ngIf="!carpismaTaramaYapiliyor"></i>
                <i class="spinner loading icon" *ngIf="carpismaTaramaYapiliyor"></i>
                <span style="margin-left:2px;">{{carpismaTaramaYapiliyor ? carpismaTaramaIlerleme + '%' : 'Tara'}}</span>
            </button>
            <button *ngIf="carpismaTaramaYapiliyor" class="ui icon mini button"
                style="padding:0.2rem 0.4rem;margin:0;font-size:9px;background:#c00;"
                (click)="taramaIptalEt()" title="Taramayı iptal et">
                <i class="stop icon"></i>
            </button>
            <span *ngIf="carpismaKontrolAktif && carpismaSayisi === 0 && !carpismaTaramaYapiliyor" style="color:#4f4;">Temiz</span>
            <button *ngIf="carpismaSayisi > 0"
                style="background:rgba(255,0,0,0.2);border:1px solid #f44;border-radius:4px;padding:2px 6px;color:#f44;cursor:pointer;font-size:9px;"
                popovertarget="carpisma-liste-popup" title="Çarpışma listesini göster">
                {{carpismaSayisi}} çarpışma
            </button>
            <button class="ui icon mini button" style="padding:0.2rem 0.4rem;margin:0;font-size:9px;background:#1a6;"
                (click)="cycleTimeAnaliziHesapla()" popovertarget="cycle-time-popup" title="Cycle Time Analizi">
                <i class="clock icon"></i>
                <span style="margin-left:2px;">Rapor</span>
            </button>
        </div>

        <!-- Çarpışma Listesi Popup -->
        <div id="carpisma-liste-popup" popover
            style="margin:0;inset:unset;position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);
                   background:rgba(20,20,25,0.98);border:2px solid #f44;border-radius:8px;padding:0;
                   backdrop-filter:blur(10px);color:white;min-width:280px;max-width:350px;max-height:60vh;
                   box-shadow:0 8px 32px rgba(0,0,0,0.8),0 0 30px rgba(255,0,0,0.3);">
            <div style="background:linear-gradient(90deg,#c00,#800);padding:8px 12px;border-radius:6px 6px 0 0;
                        display:flex;justify-content:space-between;align-items:center;">
                <span style="font-weight:bold;font-size:12px;">Çarpışma Noktaları ({{carpismaNoktalar.length}})</span>
                <button popovertarget="carpisma-liste-popup" popovertargetaction="hide"
                    style="background:none;border:none;color:white;cursor:pointer;font-size:16px;">X</button>
            </div>
            <div style="max-height:300px;overflow-y:auto;padding:6px;">
                <div *ngIf="carpismaNoktalar.length === 0" style="text-align:center;color:#888;padding:20px;">
                    <span *ngIf="!carpismaTaramaYapiliyor && carpismaTaramaIlerleme < 100">Henüz tarama yapılmadı</span>
                    <span *ngIf="!carpismaTaramaYapiliyor && carpismaTaramaIlerleme === 100" style="color:#4f4;">Çarpışma bulunamadı</span>
                    <span *ngIf="carpismaTaramaYapiliyor">Taranıyor... %{{carpismaTaramaIlerleme}}</span>
                </div>
                <div *ngFor="let nokta of carpismaNoktalar; let i = index"
                    style="display:flex;align-items:center;gap:6px;padding:6px 8px;margin-bottom:4px;
                           background:rgba(255,0,0,0.1);border:1px solid rgba(255,0,0,0.3);border-radius:4px;
                           cursor:pointer;transition:all 0.15s;"
                    (click)="tiklandiCarpismaNoktasi(nokta)"
                    (mouseenter)="$event.target.style.background='rgba(255,0,0,0.25)'"
                    (mouseleave)="$event.target.style.background='rgba(255,0,0,0.1)'">
                    <span style="background:#f44;color:white;border-radius:50%;width:18px;height:18px;
                                 display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:bold;">
                        {{i + 1}}
                    </span>
                    <div style="flex:1;font-size:9px;">
                        <div style="color:#faa;">Poz: {{nokta.pozIdx}} | {{nokta.zaman}}</div>
                        <div style="color:#888;font-family:monospace;">
                            X:{{nokta.x.toFixed(2)}} Y:{{nokta.y.toFixed(2)}} Z:{{nokta.z.toFixed(2)}}
                        </div>
                    </div>
                    <i class="arrow right icon" style="color:#f44;"></i>
                </div>
            </div>
            <div style="padding:6px 12px;border-top:1px solid #333;font-size:8px;color:#888;text-align:center;">
                Tıklayarak çarpışma noktasına git
            </div>
        </div>

        <!-- Cycle Time Raporu Component -->
        <fiko-cycle-time-rapor
            #cycleTimeRapor
            [noktalar]="noktalar"
            [reelIlerleme]="reelIlerleme"
            [renkIsleme]="renkIsleme"
            [renkYaklasma]="renkYaklasma"
            [renkUzaklasma]="renkUzaklasma"
            [renkBosta]="renkBosta"
            popoverId="cycle-time-popup">
        </fiko-cycle-time-rapor>
    </div>

</div>
